import { Link } from "@mui/material";
import { useTranslation, Trans } from "react-i18next";
import {
  replaceMainSiteLinkHostname,
  getModalityFromHostname,
} from "../../services/Utils";
import SurveyStatusPage from "./SurveyStatusPage";

const VITE_CHAT_HOST =
  import.meta.env.VITE_CHAT_HOST || "https://chat.988lifeline.org";
const VITE_SMS_NUMBER = import.meta.env.VITE_SMS_NUMBER || "988";

const SessionInvalidPage = () => {
  const { t } = useTranslation("common");
  const isSms = getModalityFromHostname(window?.location?.hostname) === "sms";

  const body = isSms ? (
    <Trans
      i18nKey="sessionInvalid.smsMessage"
      ns="common"
      components={{ returnLink: <Link href={`sms:${VITE_SMS_NUMBER}`} /> }}
    />
  ) : (
    t("sessionInvalid.message")
  );
  const buttonText = isSms
    ? t("sessionInvalid.smsButton")
    : t("sessionInvalid.button");
  const buttonHref = isSms
    ? `sms:${VITE_SMS_NUMBER}`
    : replaceMainSiteLinkHostname(t("chatHomeUrl"), VITE_CHAT_HOST);

  return (
    <SurveyStatusPage
      title={t("sessionInvalid.title")}
      body={body}
      buttonText={buttonText}
      buttonHref={buttonHref}
    />
  );
};

export default SessionInvalidPage;
